<template>
  <div class="page-content-wrapper">
    <div class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row">
          <div class="col-lg-6 m-b-10 d-flex">
            <div class="card text-center h-100 confirm">
              <div class="card-header"></div>
              <div class="card-body">
                <div class="questiondescription padding-50">
                  <img src="../../assets/img/happy-duotone.svg" alt="hoe-was-je-dienst" height="110px" class="confirmicon">
                  <p class="bigbold text-white padding-30">{{ $t('survey_finish') }}</p>
                </div>
                <div class="btn-group btn-group-justified w-100 p-b-25">
                  <button class="nextbutton text-24-g bg-white"
                          @click="submitDone">
                    {{ $t('survey_send') }}
                  </button>
                </div>
                <button class="btn-link text-white"
                        @click="$emit('back-survey')">
                  {{ $t('survey_back') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    props: ['survey_id'],
    methods: {
      ...mapActions([
        'setSurveyStatus',
      ]),
      submitDone() {
        console.log('Survey status completed')
        this.setSurveyStatus(
          {
            sid: this.survey_id,
            status: 3,
          }
        )
        this.$router.push({ name: 'home' })
      },
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/surveys/SurveyConfirm.vue